module.exports = __webpack_public_path__ + "static/media/proj2-tankfarm.551ae672.jpg";